import { toShortNumFormat } from '@common/lib/toShortNumFormat';
import Decimal from 'decimal.js';

interface ToDifferenceFormatArgs {
  value: number;
  diminutive: number;
  subtractive: number;
}

const toDifferenceFormat = ({
  value,
  diminutive,
  subtractive,
}: ToDifferenceFormatArgs): string => {
  const diminutiveDecimal = new Decimal(diminutive);
  const subtractiveDecimal = new Decimal(subtractive);
  const diffDecimal = diminutiveDecimal.minus(subtractiveDecimal);
  const isNegative = diffDecimal.isNegative();

  let fixedCof: number | undefined;

  if (
    diminutiveDecimal.toString().length === subtractiveDecimal.toString().length
  ) {
    const diffString = isNegative
      ? diffDecimal.abs().toString()
      : diffDecimal.toString();
    fixedCof = String(value).length - diffString.length;
  }

  return toShortNumFormat(value, { fixedCof });
};

export { toDifferenceFormat };
